module.exports = __webpack_public_path__ + "img/new5.903c3a2c.jpg";